import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23ZM6.76855 11.8658L10.2327 9.86584L9.23266 8.13379L5.76855 10.1338L6.76855 11.8658ZM18.2327 10.1338L14.7686 8.13379L13.7686 9.86584L17.2327 11.8658L18.2327 10.1338ZM9.40058 14.4991L8.89985 13.6335L7.16864 14.6349L7.66936 15.5005C8.53238 16.9924 10.1479 17.9998 11.9998 17.9998C13.8518 17.9998 15.4673 16.9924 16.3303 15.5005L16.831 14.6349L15.0998 13.6335L14.5991 14.4991C14.0789 15.3984 13.109 15.9998 11.9998 15.9998C10.8907 15.9998 9.9208 15.3984 9.40058 14.4991Z"}}]};

const WrySmileFilled = Vue.extend<IconProps>({
  name: 'WrySmileFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'wry-smile-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default WrySmileFilled;
